import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SkipSelf, ViewEncapsulation } from '@angular/core';
import { ControlContainer, UntypedFormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'mat-table-filter',
  templateUrl: './mat-table-filter.component.html',
  styleUrls: ['./mat-table-filter.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class MatTableFilterComponent {
  public expended: boolean;
  @Input() formGroup: UntypedFormGroup = new UntypedFormGroup({});
  @Output() public onChangeBadge = new EventEmitter<any>();
  @Output() public onConfirmFilter = new EventEmitter<any>();
  constructor() { }
  toogle() {
    this.expended = !this.expended;
  }
  doFilter() {
    this.onChangeBadge.emit(this.filterCount());
    this.onConfirmFilter.emit();
    this.expended = false;
  }
  filterCount(): number {
    let myObj = this.formGroup.value;
    Object.keys(myObj).forEach((key) => (!myObj[key]) && delete myObj[key]);
    return Object.keys(myObj).length;
  }
  clearFilter() {
    this.expended = false;
    this.formGroup.reset();
    this.doFilter();
  }
}
